import Vue from 'vue';
import Router, { Route } from 'vue-router';

import LoginController from '@/assets/ts/controller/LoginController';
import store from './store/store';
import views, { routesLinkMap } from './routes';
import OfflineController from '@/assets/ts/controller/OfflineController';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import { ControleAcessoController } from './assets/ts/controller/ControleAcessoController';
// importar todas as telas que serao roteadas

Vue.use(Router);


/**
 * Classe que controla a lógica de roteamento e manipulação de rotas dinâmicas.
 * @extends Vue
 */
export class RouterController extends Vue {
  /**
   * Atualiza as rotas com base no parâmetro `idpgrestringetelaregist` do usuário.
   * 
   * Esta função percorre todas as rotas definidas em `views` e ajusta a propriedade `showInMenu`
   * com base no valor de `idpgrestringetelaregist`. Apenas as rotas que não tem a propriedade `offline` = true
   * têm a propriedade `showInMenu` atualizada.
   * 
   * @static
   */
  static updateRoutes() {
    const userRestriction = store.getters.user.idpgrestringetelaregist;

    if(!userRestriction) return;

    views.forEach(route => {
      if (!route.offline) {
        route.showInMenu = !userRestriction;
      }
    });
  }
}


const RouteVerificationParams = {
  videoCameraVideoTagId: '#camera__area--view',
};

const routes = views.map((storeRoute: any) => {
  const route = {
    path: storeRoute.link,
    component: storeRoute.component,
    meta: storeRoute.meta
  };

  return route;
});

const defaultRouteStore = views.find(
  (storeRoute: any) => storeRoute.default);

if (defaultRouteStore) {
  const defaultRout = {
    path: '/*',
    component: defaultRouteStore.component,
    meta: defaultRouteStore ? defaultRouteStore.meta : {}
  }

  routes.push(defaultRout);
}

const router = new Router({
  routes,
});

store.commit('updateViews', views);

router.beforeEach((to, from, next) => {
  const route = routesLinkMap[to.path];
  const registroPontoRoute = getRegistroPontoRoute();

  // Se o usuário deve ser redirecionado para /registroPonto, faz isso antes de qualquer outra validação
  if (shouldRedirectToRegistroPonto(to) && from.path !== registroPontoRoute) {
    if (to.path !== registroPontoRoute) {
      next(registroPontoRoute);
    } else {
      next(); // Evita loop infinito
    }
    
    return;
  }


  // Chamando a função para validar a permissão de acesso à rota /controleAcesso
  validarAcessoControleDeAcesso(to, from, next);

  // Chamando a função para validar a permissão de acesso à rota /IndicadoresVariacaoSalarial
  validarAcessoIndicadoresVariacaoSalarial(to, from, next);

  const controlePermissao = to.meta && to.meta.permission;

  // Guard para validar as permissões do Controle de Acesso
  ControleAcessoController.verificarControlePermissaoRota(controlePermissao, next);
  
  // Verifica se a rota não está na lista de telas com suporte offline
  if (!route.offline && OfflineController.checkIsOffline()) {
    SnackbarUtils.showMessage('Conexão necessária: Esta tela requer acesso à internet.', SnackbarUtils.TYPE_INFO);
  }

  LoginController.redirect(to, from, next, RouteVerificationParams);
});
 

// Função para validar o acesso à rota /controleAcesso
function validarAcessoControleDeAcesso(to, from, next) {
  if (to.path === '/controleAcesso' && !store.getters.user.dp) {
    next('/');
  }
}

// Função para validar o acesso à rota /controleAcesso
function validarAcessoIndicadoresVariacaoSalarial(to, from, next) {
  if (to.path.toLowerCase() === '/indicadoresvariacaosalarial' && !store.getters.user.dp) {
    next('/');
  }
}

//Essa função retorna true se o usuário deve obrigatoriamente ir para /registroPonto. (Evitando conflitos com o Controle de Acesso)
function shouldRedirectToRegistroPonto(to: Route): boolean {
  const route = routesLinkMap[to.path];
  const isOffline = OfflineController.checkIsOffline();

  const idpgrestringeregist = store.getters.user.idpgrestringeregist;
  const idpgrestringetelaregist = store.getters.user.idpgrestringetelaregist;

  if (idpgrestringeregist && !isOffline) {
    return true;
  }

  if (idpgrestringetelaregist && !route.offline) {
    return true;
  }

  return false;
}

export const getRegistroPontoRoute = (): string => {
  return '/registroPonto';
}

export default router;
